import {Component, Input, OnInit} from '@angular/core';
import {SwitchLanguageService} from "../../../../../core/switch-language/switch-language.service";

@Component({
    selector: 'app-mat-spinner-overlay',
    templateUrl: './mat-spinner-overlay.component.html',
    styleUrls: ['./mat-spinner-overlay.component.scss'],
    standalone: false
})
export class MatSpinnerOverlayComponent implements OnInit {

  constructor(private switchLanguageService: SwitchLanguageService) { }

  @Input() value = 100;
  @Input() diameter = 300;
  @Input() mode = 'indeterminate';
  @Input() strokeWidth = 10;
  @Input() overlay = false;
  @Input() color = 'primary';
  isLanguageSpanish: boolean = false

  ngOnInit() {
      if(this.switchLanguageService.getSavedLanguageCode() == "es")
        this.isLanguageSpanish = true
  }


}
